import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';

@Component({
  selector: 'app-shift-based',
  templateUrl: './shift-based.component.html',
  styleUrls: ['./shift-based.component.css']
})

export class ShiftBasedComponent extends BaseListCtl {

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.SHIFT, locator, route);
  }

  populateForm(form, data) {
    form.id = data.id;
    form.name = data.name;
    form.startTime = data.startTime;
    form.endTime = data.endTime;
    console.log('-------->', data);
  }
}
